var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDealLost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C12.0333 0 9.13319 0.879735 6.66645 2.52796C4.19971 4.17618 2.27713 6.51886 1.14181 9.25975C0.00649925 12.0006 -0.290551 15.0166 0.288227 17.9263C0.867006 20.8361 2.29562 23.5088 4.3934 25.6066C6.49119 27.7044 9.16394 29.133 12.0736 29.7118C14.9834 30.2905 17.9994 29.9935 20.7403 28.8582C23.4811 27.7229 25.8238 25.8003 27.472 23.3335C29.1203 20.8668 30 17.9667 30 15C29.9955 11.0231 28.4137 7.21042 25.6017 4.39835C22.7896 1.58627 18.9769 0.0044806 15 0ZM15 27.8571C11.5901 27.8571 8.31981 26.5025 5.90863 24.0914C3.49745 21.6802 2.14286 18.4099 2.14286 15C2.14286 11.5901 3.49745 8.31981 5.90863 5.90863C8.31981 3.49744 11.5901 2.14286 15 2.14286V15L24.087 24.0872C22.8953 25.2831 21.479 26.2318 19.9196 26.8788C18.3602 27.5257 16.6883 27.8582 15 27.8571Z",
    fill: "#FF5D36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealLost);
export default __webpack_public_path__ + "static/media/DealLost.394ffd60a7d6a6e1211654b667312e71.svg";
export { ForwardRef as ReactComponent };